import { render, staticRenderFns } from "./ekko.terms-of-service.vue?vue&type=template&id=af93fa88&scoped=true&"
import script from "./ekko.terms-of-service.vue?vue&type=script&lang=ts&"
export * from "./ekko.terms-of-service.vue?vue&type=script&lang=ts&"
import style0 from "./ekko.terms-of-service.vue?vue&type=style&index=0&id=af93fa88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af93fa88",
  null
  
)

export default component.exports